import {
  AdmActiveFacet,
  ClearFilters,
  CustomFacet,
  CustomFilter,
  FilterTitle,
  ReverseBooleanFacet,
  SortingView
} from "components/common";
import { SidebarFilterWrapper } from "components/search/buckets/common";
import { isSmallLabCodesystem } from "components/search/buckets/utils";
import { useStoreContext } from "context/StoreProvider";
import { Col } from "react-bootstrap";
import { isDesktop } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { codesystemsEndpointName } from "utils";

import SearchFieldFilter from "./searchFieldFilterOldForKis";

type SidebarFilterProps = {
  searchTerm: string;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const SidebarFilter = ({ searchTerm }: SidebarFilterProps) => {
  const { t } = useTranslation();
  const { state } = useStoreContext();
  const { codeSystem } = state;
  const { pathname } = useLocation();

  return (
    <SidebarFilterWrapper
      $isDesktop={isDesktop}
      className={`d-flex flex-column gap-3 pt-3 ${
        isSmallLabCodesystem(pathname) ? "pt-lg-0" : "pt-lg-2"
      }`}
    >
      {/* Wrapping all boolean filters, because the parent handles gap between filters */}
      <span className="d-flex flex-column gap-2">
        <FilterTitle
          hasBorderBottom={true}
          className="d-flex justify-content-between"
        >
          {t("nlkPage.filter.title")}
          <ClearFilters />
        </FilterTitle>
        {/* All the codesystems will probably have different filters, 
						may be a good idea to create a switch case if this code is too long */}
        {codeSystem !== codesystemsEndpointName.adm && (
          <CustomFacet
            field="active"
            label={t("search.filters.showInactiveCodes")}
            filterType="any"
            view={ReverseBooleanFacet}
          />
        )}
      </span>

      <Col className="d-flex flex-column" xs="auto">
        {isSmallLabCodesystem(pathname) && (
          <SortingView
            label={t("nlkPage.sort.title")}
            sortOptions={[
              {
                name: t("search.sorting.relevance"),
                value: "",
                direction: ""
              },
              {
                name: t("search.sorting.nameNorwegian"),
                value: "name_norwegian",
                direction: "asc"
              },
              {
                name: t("search.sorting.validFrom"),
                value: "valid_from",
                direction: "asc"
              },
              {
                name: t("search.sorting.validTo"),
                value: "valid_to",
                direction: "asc"
              }
            ]}
          />
        )}

        {codeSystem === codesystemsEndpointName.adm && (
          <SortingView
            label={t("nlkPage.sort.title")}
            sortOptions={[
              {
                name: t("search.sorting.relevance"),
                value: "",
                direction: ""
              },
              {
                name: t("general.id"),
                value: "compact_code",
                direction: "asc"
              },
              {
                name: t("general.codesystem"),
                value: "name_norwegian",
                direction: "asc"
              },
              {
                name: t("adminPage.results.owner"),
                value: "owner_name",
                direction: "asc"
              },
              {
                name: t("search.sorting.category"),
                value: "text_max_60",
                direction: "asc"
              },
              {
                name: t("search.sorting.nameAdm"),
                value: "parent_code",
                direction: "asc"
              }
            ]}
          />
        )}
      </Col>

      {/* This should be uncommented when the elastic backend is ready */}
      {codeSystem === codesystemsEndpointName.adm && (
        <>
          <SearchFieldFilter
            label={"Søk i koder"}
            searchField="code"
            removedWhenSelected={false}
            initialState={false}
          />
          <CustomFacet
            field="status_text"
            label={"Vis inaktive kodeverk"}
            view={AdmActiveFacet}
            filterType="any"
            isFilterable
          />
          <CustomFacet
            field="owner_name"
            label={t("adminPage.results.owner")}
            view={CustomFilter}
            filterType="any"
            isFilterable
            show={20}
            showDisabledOptions={false}
          />
        </>
      )}
    </SidebarFilterWrapper>
  );
};

export default SidebarFilter;
